import { toVueComponent } from "@scalar-org/vue-render";
import { html } from "../../helpers/html-template.js";
import { EditorClasses } from "../../styles.js";
import { slugify } from "../../utilities/index.js";
function guideHeadingHtml(props) {
  const level = Number.parseInt(props.level, 10);
  const tag = `h${level}`;
  const id = level <= 4 ? props.slug ?? props.uid : void 0;
  const linkHtml = html`
    <button 
      class="notify-container"
      aria-label="Copy link to heading">
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        fill="currentColor" 
        viewBox="0 0 256 256"
        aria-hidden="true"
        class="icon notify">
        <path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"></path>
      </svg>
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        fill="currentColor"
        viewBox="0 0 256 256"
        aria-hidden="true"
        class="icon">
        <path d="M224,88H175.4l8.47-46.57a8,8,0,0,0-15.74-2.86l-9,49.43H111.4l8.47-46.57a8,8,0,0,0-15.74-2.86L95.14,88H48a8,8,0,0,0,0,16H92.23L83.5,152H32a8,8,0,0,0,0,16H80.6l-8.47,46.57a8,8,0,0,0,6.44,9.3A7.79,7.79,0,0,0,80,224a8,8,0,0,0,7.86-6.57l9-49.43H144.6l-8.47,46.57a8,8,0,0,0,6.44,9.3A7.79,7.79,0,0,0,144,224a8,8,0,0,0,7.86-6.57l9-49.43H208a8,8,0,0,0,0-16H163.77l8.73-48H224a8,8,0,0,0,0-16Zm-76.5,64H99.77l8.73-48h47.73Z"></path>
      </svg>
    </button>
  `;
  return html`
    <${tag}
      id="${id}"
      class="scroll-pad interaction-observer-heading ${EditorClasses.Heading}"
      data-level="${props.level}"
      data-scalar-type="heading">
      <!-- WARNING: Without the dedicated closing tag nodes after the ssg-children will not be rendered -->
      <ssg-children></ssg-children>
      ${props.level <= 4 && linkHtml}
    </${tag}>
  `;
}
const ScalarHeadingVue = toVueComponent(
  /** Synchronous render function for the Vue component that uses slots for the icon */
  (props) => guideHeadingHtml(props),
  {
    level: Number,
    uid: String,
    isEditable: Boolean,
    slug: String
  }
);
function guidePageTitleHtml(props) {
  const description = props.description ? html`<p class="subheading" role="doc-subtitle">${props.description}</p>` : "";
  return html`
    <div class="${EditorClasses.PageTitle}">
      <h1
        id="${slugify(props.title)}"
        data-scalar-type="heading"
        data-level="1"
        class="heading scroll-pad interaction-observer-heading ${EditorClasses.Heading}"
        >
        ${props.title}
      </h1>
      ${description}
    </div>
  `;
}
const ScalarPageTitleVue = toVueComponent(
  /** Synchronous render function for the Vue component that uses slots for the icon */
  (props) => guidePageTitleHtml(props),
  {
    title: String,
    description: String
  }
);
export {
  ScalarHeadingVue,
  ScalarPageTitleVue,
  guideHeadingHtml,
  guidePageTitleHtml
};
//# sourceMappingURL=component.js.map
